import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { EbookMockup } from './EbookMockup';
import { Sparkles, Copy, Zap, Star } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden" data-id="element-154">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-glow rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-155"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 lg:gap-8 items-center relative z-10" data-id="element-156">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-start" data-id="element-157">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold/30 bg-gold/5 backdrop-blur-sm mb-8" data-id="element-158">
            <div className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-159"></div>
            <span className="text-gold text-[10px] uppercase tracking-[0.2em] font-medium" data-id="element-160">
              500 Prompts · Edición Profesional
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-cream mb-6 text-balance" data-id="element-161">
            500 prompts que{' '}
            <span className="text-gold italic" data-id="element-162">ahorran horas</span> de trabajo.
          </h1>

          <p className="text-cream/70 text-lg md:text-xl font-light leading-relaxed mb-10 max-w-lg" data-id="element-163">
            Aprende a crear contenido, vender más, organizar tu negocio y
            recuperar tu tiempo usando prompts de IA diseñados para
            profesionales modernos.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-164">
            <Button variant="primary" data-id="element-165">Obtener Acceso Inmediato</Button>
            <Button variant="secondary" data-id="element-166">Ver Qué Incluye</Button>
          </div>

          <div className="mt-12 flex items-center gap-4 text-sm text-cream/50" data-id="element-167">
            <div className="flex -space-x-2" data-id="element-168">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-black bg-black-200 overflow-hidden" data-id="element-169">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover opacity-80" data-id="element-170" />
                </div>)}
            </div>
            <div className="flex flex-col" data-id="element-171">
              <div className="flex text-gold text-xs" data-id="element-172">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={12} fill="currentColor" data-id="element-173" />)}
              </div>
              <span className="text-xs mt-1" data-id="element-174">
                +2,000 profesionales ya lo usan
              </span>
            </div>
          </div>
        </motion.div>

        {/* Visual Content */}
        <div className="relative h-[560px] md:h-[680px] lg:h-[760px] flex items-center justify-center lg:justify-end" data-id="element-175">
          <EbookMockup className="z-10 max-w-[420px] md:max-w-[560px] lg:max-w-[680px]" image="https://cdn.magicpatterns.com/uploads/2KzzAymubxUoD4Tic3zFGm/500_PROMPS_COVER.png" data-id="element-176" />

          {/* Floating Badges */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} className="absolute top-10 right-10 md:right-20 bg-black-100/80 backdrop-blur-md border border-gold/20 px-4 py-3 rounded-lg shadow-glass flex items-center gap-3 z-20" data-id="element-177">
            <div className="bg-gold/10 p-2 rounded-md" data-id="element-178">
              <Sparkles className="text-gold" size={16} data-id="element-179" />
            </div>
            <div className="flex flex-col" data-id="element-180">
              <span className="text-cream text-xs font-medium" data-id="element-181">
                500 Prompts
              </span>
              <span className="text-cream/50 text-[10px]" data-id="element-182">
                Listos para usar
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 1,
          duration: 0.8
        }} className="absolute bottom-20 left-0 md:left-10 bg-black-100/80 backdrop-blur-md border border-gold/20 px-4 py-3 rounded-lg shadow-glass flex items-center gap-3 z-20" data-id="element-183">
            <div className="bg-gold/10 p-2 rounded-md" data-id="element-184">
              <Copy className="text-gold" size={16} data-id="element-185" />
            </div>
            <div className="flex flex-col" data-id="element-186">
              <span className="text-cream text-xs font-medium" data-id="element-187">
                Copy & Paste
              </span>
              <span className="text-cream/50 text-[10px]" data-id="element-188">Cero fricción</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 1.2,
          duration: 0.8
        }} className="absolute top-1/2 -right-4 md:-right-8 bg-black-100/80 backdrop-blur-md border border-gold/20 px-4 py-3 rounded-lg shadow-glass flex items-center gap-3 z-20" data-id="element-189">
            <div className="bg-gold/10 p-2 rounded-md" data-id="element-190">
              <Zap className="text-gold" size={16} data-id="element-191" />
            </div>
            <div className="flex flex-col" data-id="element-192">
              <span className="text-cream text-xs font-medium" data-id="element-193">
                IA + Productividad
              </span>
              <span className="text-cream/50 text-[10px]" data-id="element-194">
                Resultados en segundos
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}